import React, { useEffect, useMemo, useState } from 'react';
import { Collapse } from 'react-bootstrap';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useHistory, useLocation } from 'react-router-dom';
import qs from 'qs';
import { routesAppearance } from '../../../../helpers';
import Tooltip from '../../../../../../components/Tooltip';

const TwigFilesGroup = ({ title, files, isFullScreen }) => {
  const history = useHistory();
  const location = useLocation();
  const queryString = qs.parse(location.search.slice(1));
  const editRoute = useMemo(() => routesAppearance.find((route) => route.code === 'file-edit'), [])

  const [width, setWidth] = useState(0);
  const [isOpen, setOpen] = useState(window.screen.width >= 768);
  const tooltipLeft = width >= 1360;

  useEffect(() => {
    const observer = new ResizeObserver((entries) => {
      const rect = entries[0].contentRect;
      setWidth(rect.width);
    });
    observer.observe(document.documentElement);

    return () => {
      observer.unobserve(document.documentElement);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onEditFile = (name) => {
    history.push({
      pathname: editRoute.link,
      search: `name=${name}&theme_id=${queryString.theme_id}`,
    })
  }

  return (
    <div className="twig-files-menu__group">
      <div className="twig-files-menu__group-title" onClick={() => setOpen(!isOpen)}>
        <div className="twig-files-menu__group-folder">
          <i className={classNames({
            'fas fa-folder-open': isOpen,
            'fas fa-folder': !isOpen,
          })}
          />
        </div>
        <div>{title}</div>
      </div>
      {files.map((file, index) => (
        <Collapse key={`file-${index}`} in={isOpen}>
          <div className="twig-files-menu__group-items">
            <Tooltip
              placement={!isFullScreen && tooltipLeft ? 'left' : 'right'}
              tooltipClass={classNames({
                tooltip__left: !isFullScreen && tooltipLeft,
                tooltip__right: isFullScreen || !tooltipLeft,
              })}
              text={file.last_modified ? `Modified ${file.last_modified}` : null}
            >
              <div
                onClick={() => onEditFile(file.title)}
                className={classNames('twig-files-menu__group-item', {
                  'twig-files-menu__group-item-active': queryString?.name === file.title,
                })}
                title={file.title}
              >
                <div className="twig-files-menu__group-file">
                  <i className={classNames({
                    'far fa-file': !file.last_modified,
                    'fas fa-file': file.last_modified,
                  })}
                  />
                </div>
                <div className="twig-files-menu__group-file-name">{file.title}</div>
              </div>
            </Tooltip>
          </div>
        </Collapse>
      ))}
    </div>
  )
}

TwigFilesGroup.propTypes = {
  title: PropTypes.string,
  files: PropTypes.array,
  isFullScreen: PropTypes.bool,
};

export default TwigFilesGroup;
